import React from 'react';

import { DropdownToggleInterface } from '@neptune/shared/venus-domain';
import { bemBlock, Button, Dropdown } from '@neptune/shared/venus-ui';

import { ColorPicker } from './ColorPicker';
import { useColorPicker } from './useColorPicker';

import './ColorPickerDropdown.less';

const block = bemBlock('color-picker-dropdown');

type ColorPickerDropdownBaseProps = {
  label?: string;
  color?: string;
  className?: string;
  presetColors?: string[];
  toggle?: React.ReactElement<DropdownToggleInterface> | string;
  dataRole?: string;
  onAddPresetColor?: (color: string) => void;
};

type ColorPickerDropdownClearableProps = ColorPickerDropdownBaseProps & {
  clearable: true;
  onChange?: (color: string | undefined) => void;
};

type ColorPickerDropdownStandardProps = ColorPickerDropdownBaseProps & {
  clearable?: false;
  onChange?: (color: string) => void;
};

type ColorPickerDropdownProps =
  | ColorPickerDropdownStandardProps
  | ColorPickerDropdownClearableProps;
/**
 * @deprecated Use ColorPickerMenu instead
 */
export function ColorPickerDropdown(props: ColorPickerDropdownStandardProps): JSX.Element;
/**
 * @deprecated Use ColorPickerMenu instead
 */
export function ColorPickerDropdown(props: ColorPickerDropdownClearableProps): JSX.Element;

/**
 * @deprecated Use ColorPickerMenu instead
 */
export function ColorPickerDropdown({
  className,
  dataRole,
  color,
  label = 'Change color',
  toggle,
  presetColors,
  onChange,
  clearable,
  onAddPresetColor,
}: ColorPickerDropdownProps) {
  const { handleExpand, handleCollapse, restoreColor, handleOnChange } = useColorPicker({
    color,
    onAddPresetColor,
    onChange,
    clearable,
  } as ColorPickerDropdownProps);

  const renderToggle = () => {
    if (toggle) {
      return toggle;
    }

    return (
      <Dropdown.SubmenuToggle
        icon="color"
        label={label}
        disableChevron
        component="label"
        data-role={dataRole}
      />
    );
  };

  return (
    <Dropdown
      toggle={renderToggle()}
      onExpand={handleExpand}
      onCollapse={handleCollapse}
      attachment="top left"
      targetAttachment="top right"
      constraints={Dropdown.CONSTRAINT_TO_WINDOW}
    >
      {({ collapse }) => (
        <Dropdown.Menu withPadding="none">
          <ColorPicker
            className={className}
            defaultValue={color}
            onChange={handleOnChange}
            onCancel={restoreColor}
            presetColors={presetColors}
          />
          {clearable && onChange && (
            <>
              <Dropdown.Separator />
              <Button
                className={block('reset-button')}
                variant="transparent"
                onClick={() => {
                  onChange(undefined);
                  collapse();
                }}
              >
                Reset to defaults
              </Button>
            </>
          )}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
}
